var functions = {};

function bindEvent(element, eventName, eventHandler) {
    if (element.addEventListener) {
        element.addEventListener(eventName, eventHandler, false);
    } else if (element.attachEvent) {
        element.attachEvent('on' + eventName, eventHandler);
    }
}

bindEvent(window, 'message', function (e) {
    let methodName = e.data.name && e.data.name.toLowerCase()
    var method = functions[methodName];
    method && method(e.data);
});

function listen(evt, cb) {
    let found = functions[evt.toLowerCase()];
    if (found) throw new Error("El evento '" + evt.toLowerCase() + "' ya ha sido definido");
    functions[evt.toLowerCase()] = cb;
}

function sendEvent(frame, evt, data) {
    let eventObject = {
        name: evt,
        data: data
    };
    var objIframe = frame;
    if (typeof frame == 'string') {
        objIframe = document.getElementById(frame);
    }
    eventObject.frame = objIframe.name;
    objIframe.contentWindow && objIframe.contentWindow.postMessage(eventObject, '*');
}

export { sendEvent, listen };


// WEBPACK FOOTER //
// ./Statics/scripts/common/frame-event.js